module.exports = __webpack_public_path__ + "img/ninety-nine-logo.6419dc93.svg";